import { cdnPhotographers, Photographer, photographers, unknownPhotographer } from "./data"

export const getPhotographer = (handle: string): Photographer => photographers.find(e => e.handle === handle) || unknownPhotographer

export const getPhotographerImage = (photographer: Photographer): string => `${cdnPhotographers}${photographer.handle}.jpg`

export const getPhotographerTwitterUrl = (photographer: Photographer): string => `https://twitter.com/${photographer.handle}`